import React                from 'react';
import { Observe }               from 'rewire-core';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import timecardSummaryModel      from './TimecardSummaryModel';
import scheduleControlsModel     from '../schedule/ScheduleControlsModel';

const TimecardSummaryFooter = React.memo(() => {
  return <Observe render={() => (
    <MainContentFooterPaging model={timecardSummaryModel.pagingModel} hidePageCounts={!!scheduleControlsModel.scheduleGroupsPermitted.length} />
  )} />;
});

export default TimecardSummaryFooter;